import React from 'react';
import classnames from 'classnames';
import { Button, ButtonProps as AButtonProps } from 'antd';
import './style.scss';

type ButtonType = Parameters<typeof Button>[0]['type'];

export type ButtonProps = {
  type?: ButtonType | 'secondary';
} & Omit<AButtonProps, 'type'>;

interface CustomProps extends React.FC<ButtonProps> {
  Group: typeof Button.Group;
}

const CustomButton: CustomProps = ({
  type,
  className,
  children,
  ...remain
}) => {
  return (
    <Button
      {...remain}
      className={classnames(className, {
        'btn-secondary': type === 'secondary',
      })}
      type={type === 'secondary' ? 'primary' : type}
    >
      {children}
    </Button>
  );
};

CustomButton.Group = Button.Group;

export default CustomButton;
